import script from "./Status.vue?vue&type=script&setup=true&lang=js"
export * from "./Status.vue?vue&type=script&setup=true&lang=js"

import "./Status.vue?vue&type=style&index=0&id=420652a7&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/topik-vue/topik-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-420652a7"]])

export default __exports__